import { Component, OnInit } from '@angular/core';
import { WebService } from 'src/app/service/web.service';
import { Web } from 'src/app/models/web';

@Component({
  selector: 'app-detalle-web',
  templateUrl: './detalle-web.component.html',
  styleUrls: ['./detalle-web.component.css']
})
export class DetalleWebComponent implements OnInit {
  web: Web;

  constructor(private dataservice: WebService) {
    this.web = dataservice.web;
   }

  ngOnInit() {
    // ocultar grafica Figma
    const valorFigma = this.web.porcentajeFigma;
    if (valorFigma === '0' || valorFigma === '') {

      document.querySelector('#figma').parentElement.parentElement.style.display = 'none';
    }
    // ocultar grafica Html y Css
    const valorHtml = this.web.porcentajeHtmlyCss;
    if (valorHtml === '0' || valorHtml === '') {

      document.querySelector('#htmlycss').parentElement.parentElement.style.display = 'none';
    }
     // ocultar grafica Bootstrap
    const valorBootstrap = this.web.porcentajeBootstrap;
    if (valorBootstrap === '0' || valorBootstrap === '') {

      document.querySelector('#bootstrap').parentElement.parentElement.style.display = 'none';
    }
     // ocultar grafica Wordpress
    const valorWordpress = this.web.porcentajeWordpress;
    if (valorWordpress === '0' || valorWordpress === '') {

      document.querySelector('#wordpress').parentElement.parentElement.style.display = 'none';
    }
    // ocultar grafica Photoshop
    const valorPhotoweb = this.web.porcentajePhotoshop;
    if (valorPhotoweb === '0' || valorPhotoweb === '') {

      document.querySelector('#photoweb').parentElement.parentElement.style.display = 'none';
    }

    // ocultar imgweb3
    const valorImgweb3 = this.web.imagenWeb3;
    if (valorImgweb3 === '') {

      document.querySelector('#imgweb3').parentElement.parentElement.parentElement.style.display = 'none';
    }

    // ocultar imgweb4
    const valorImgweb4 = this.web.imagenWeb4;
    if (valorImgweb4 === '') {

      document.querySelector('#imgweb4').parentElement.parentElement.style.display = 'none';
    }

    // ocultar imgweb5
    const valorImgweb5 = this.web.imagenWeb5;
    if (valorImgweb5 === '') {

      document.querySelector('#imgweb5').parentElement.parentElement.style.display = 'none';
    }

     // ocultar link
    const valorlink = this.web.web;
    if (valorlink === '') {
         document.querySelector('#linkweb').parentElement.style.display = 'none';
       }
    }

}
